import type { Element } from 'react'
import React, { Fragment } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { SmallText } from 'app/common/typography'
import { Chevron } from 'app/assets/icons'
import { Collapse } from 'react-collapse'

type Props = {
    children: Element<any>,
    color?: string,
    isOpened: boolean,
    labelKey?: string,
    label?: Element<any>,
    onClick?: () => void
}

const Collapsible = (props: Props) => {
    const { children, color, isOpened, label, labelKey, onClick } = props
    return (
        <Fragment>
            <StyledAnchor onClick={onClick}>
                {label
                    ? label
                    : labelKey && (
                          <FormattedMessage id={labelKey}>
                              {(text: string) => (
                                  <SmallText color={color}>{text}</SmallText>
                              )}
                          </FormattedMessage>
                      )}
                <Chevron
                    className={isOpened ? 'over' : 'out'}
                    color={color}
                    direction={isOpened ? 'up' : 'down'}
                />
            </StyledAnchor>
            <CollapseContainer>
                <Collapse isOpened={isOpened}>{children}</Collapse>
            </CollapseContainer>
        </Fragment>
    )
}

const StyledAnchor = styled.div`
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const CollapseContainer = styled.div`
    .ReactCollapse--collapse {
        transition: height 500ms;
    }
`

export { Collapsible }
